import { doc, $, $$ } from "./util.js";
import { mrToast } from "./toast.js";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const DEFAULT_ERROR = "Please fix the highlighted fields.";
const DEFAULT_SUCCESS = "Thanks — we'll reply within one business day.";

function initDemoForm(f) {
  f.addEventListener("submit", (e) => {
    e.preventDefault();
    if (f.classList.contains("done") || f.classList.contains("is-sending")) return;
    let first = null;
    $$("input,select,textarea", f).forEach((el) => {
      if (el.type === "checkbox" && !el.required) return;
      if (el.type === "checkbox" && el.name === "niche") return;
      let ok = el.checkValidity();
      if (el.type === "email" && el.value) ok = ok && EMAIL_RE.test(el.value);
      const wrap = el.closest(".full");
      const fld = el.closest(".fld") || (wrap && $(".fld", wrap));
      if (fld) {
        fld.classList.toggle("bad", !ok);
        if (fld.querySelector(".err")) el.setAttribute("aria-invalid", String(!ok));
      }
      if (!ok && !first) first = el;
    });
    if (first) {
      first.focus();
      mrToast(f.dataset.error || DEFAULT_ERROR, "error");
      return;
    }
    const btn = $('button[type="submit"]', f);
    const label = btn ? btn.innerHTML : "";
    f.classList.add("is-sending");
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Sending…";
    }
    setTimeout(() => {
      f.classList.remove("is-sending");
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = label;
      }
      f.classList.add("done");
      const s = $(".success", f);
      if (s) {
        s.setAttribute("tabindex", "-1");
        s.focus();
      }
      mrToast(f.dataset.success || DEFAULT_SUCCESS, "success");
    }, 900);
  });

  f.addEventListener("input", (e) => {
    const fld = e.target.closest(".fld");
    if (fld && fld.classList.contains("bad") && e.target.checkValidity()) {
      fld.classList.remove("bad");
      e.target.setAttribute("aria-invalid", "false");
    }
  });
  f.addEventListener("change", (e) => {
    if (e.target.type === "checkbox" && e.target.required && e.target.checked) {
      const w = e.target.closest(".full");
      const fl = w && $(".fld", w);
      if (fl) fl.classList.remove("bad");
    }
  });
}

export function initForms() {
  $$("form[data-form]").forEach(initDemoForm);

  // Limit niche chips to 3.
  $$(".chips").forEach((g) =>
    g.addEventListener("change", (e) => {
      if ($$("input:checked", g).length > 3) e.target.checked = false;
    })
  );

  // Contact Form 7 → same toasts as the demo forms.
  const cf7 = (type, fallback, kind) =>
    doc.addEventListener(
      type,
      (e) => {
        const msg = (e.detail && e.detail.apiResponse && e.detail.apiResponse.message) || fallback;
        mrToast(msg, kind);
      },
      false
    );
  cf7("wpcf7mailsent", DEFAULT_SUCCESS, "success");
  cf7("wpcf7invalid", DEFAULT_ERROR, "error");
  cf7("wpcf7spam", "Your message looks like spam and was not sent.", "error");
  cf7("wpcf7mailfailed", "Sorry, something went wrong. Please try again later.", "error");
}
